import { render } from "./Breadcrumb.vue?vue&type=template&id=c3c8f3fc&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=c3c8f3fc&scoped=true&lang=css"

import exportComponent from "/home/ppkd-dokumen-backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3c8f3fc"]])

export default __exports__